export enum EAccessType {
    VERIFY_RESET_PASSWORD = 'VERIFY_RESET_PASSWORD',
    CONFIRM_RESET_PASSWORD = 'CONFIRM_RESET_PASSWORD',
    CHANGE_TEMPORARY_PASSWORD = 'CHANGE_TEMPORARY_PASSWORD',
    ONBOARDING = 'ONBOARDING',
    PENDING_TWO_FACTOR_AUTH = 'PENDING_TWO_FACTOR_AUTH',
    FAT = 'FAT',
}

export const RESTRICTED_ACCESS_TYPES: EAccessType[] = [
    EAccessType.CHANGE_TEMPORARY_PASSWORD,
    EAccessType.VERIFY_RESET_PASSWORD,
    EAccessType.CONFIRM_RESET_PASSWORD,
];
